export default __webpack_public_path__ + "static/mads-9f6db3521b9973e03ba5744fb17165e6.png";